import { cn } from "@/lib/utils";
import type { WSState } from "@/lib/ws";

interface Props {
  state: WSState;
  label?: string;
}

/**
 * Heart-rate dot fuer die Header-Bar. Pulse-Emerald wenn WS offen,
 * Amber waehrend Reconnect, Coral wenn down.
 */
export function LiveIndicator({ state, label }: Props) {
  const color =
    state === "open"
      ? "bg-signal-live shadow-[0_0_12px_-2px] shadow-signal-live"
      : state === "connecting"
        ? "bg-signal-warn"
        : "bg-signal-fault";
  const text =
    label ??
    (state === "open"
      ? "LIVE"
      : state === "connecting"
        ? "RECONNECTING"
        : "OFFLINE");

  return (
    <div className="flex items-center gap-2.5">
      <span className="relative inline-flex h-2.5 w-2.5">
        <span
          className={cn(
            "absolute inline-flex h-full w-full rounded-full",
            color,
            state === "open" && "animate-pulse-dot",
          )}
        />
      </span>
      <span className="font-mono text-[10px] uppercase tracking-eyebrow text-muted-foreground">
        {text}
      </span>
    </div>
  );
}
